import React, { useEffect, useState} from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import "../App.css";


const ImageCarousel = ({ media }) => {
const [slidesPreview, setSlidesPreview] = useState(3);
const [imgHeight, setImgHeight] = useState("420px");
const [enableNav, setEnableNav] = useState(true);


useEffect(() => {
  if (window.innerWidth < 768) {
    setSlidesPreview(1);
    setImgHeight("300px");
    setEnableNav(false);
  }

}, []);
  
  return (
    <div style={{position:"absolute",width:"100%"}}>
       <Swiper
        slidesPerView={slidesPreview}
        spaceBetween={10}
        modules={[Autoplay, Pagination, Navigation]}
        pagination={{
          clickable: true,
          dynamicBullets: true
        }}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        navigation={enableNav}
        className="mySwiper"
      >
        {media.map((item, index) => (
            <SwiperSlide key={index}><img src={item.url} style={{ height: imgHeight }} /></SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default ImageCarousel;